import React, { Component } from "react";

import styles from "./TopStories.css";

class SmarterFaster extends Component {

  render() {
    return (
      <div className={styles.smarterFaster}>
        <img src={require("../../../assets/img/smarter-faster@3x.png")} alt="Smarter Faster Heading"/>
        <div className={styles.section}>
          <i>Thank you to JPMorgan Chase & Co. for underwriting the Axios Smarter Faster series, featuring leaders explaining the ideas shaping their lives and worldviews. This series contains both underwritten videos, over which Axios retains full editorial control, and branded videos co-created by Axios on behalf of JPMorgan Chase & Co. Videos are labeled accordingly below.</i>
        </div>
      </div>
    );
  }
}

export default SmarterFaster;
